import { render, staticRenderFns } from "./SideLBar.vue?vue&type=template&id=dd1fb4a4&scoped=true"
import script from "./SideLBar.vue?vue&type=script&lang=js"
export * from "./SideLBar.vue?vue&type=script&lang=js"
import style0 from "./SideLBar.vue?vue&type=style&index=0&id=dd1fb4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1fb4a4",
  null
  
)

export default component.exports